import Avatar from '@material-ui/core/Avatar';
import styled from 'styled-components/macro';

export const StyledAvatar = styled(Avatar)`
    background-color: #00aa8d;
`;
